import { faCheckCircle, faList, faSpinner, faStar, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Col, ListGroup, ListGroupItem, Modal, Row } from "react-bootstrap";
import { callWrite, DELETE_FAVORITE_LIST } from "../../amplify/appsync/write";


interface FavoriteSelectListModalProps {
    show: boolean;
    setShow: any;
    listNames: string[];
    setListNames: any;
    activeList: string;
    setSelectedList: any;
}


export const FavoriteSelectListModal = (props: FavoriteSelectListModalProps) => {

    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [selectedDelete, setSelectedDelete] = useState<any>(null);

    const handleClose = () => {
        props.setShow(false);
    };

    const deleteList = () => {
        if (selectedDelete && props.listNames.includes(selectedDelete)) {
            setIsDeleting(true);
            callWrite({
                operation: DELETE_FAVORITE_LIST,
                list_name: selectedDelete,
            })
            .then((output: any) => {
                console.log("Deleted favorite", output);
                setIsDeleting(false);
                props.setListNames([
                    ...props.listNames.filter(list => list !== selectedDelete),
                ]);
            });
        } else {
            setIsDeleting(false);
        }
    };

    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Select List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    selectedDelete ? (
                        <>
                            <Row className="mb-2">
                                <Col>
                                    Are you sure you want to delete {selectedDelete}?
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={(e: any) => {
                                            setSelectedDelete(null);
                                            deleteList();
                                        }}
                                        disabled={isDeleting}
                                    >
                                        {
                                            isDeleting ? (
                                                <FontAwesomeIcon icon={faSpinner} spin />
                                            ) : (
                                                <>Yes</>
                                            )
                                        }
                                    </Button>{' '}
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={(e: any) => {
                                            setSelectedDelete(null);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <ListGroup>
                            {
                                props.listNames.map(list => (
                                    <ListGroupItem action onClick={() => {props.setSelectedList(list); props.setShow(false)}} active={list === props.activeList}>
                                        <FontAwesomeIcon icon={list === props.activeList ? faCheckCircle : list === "favorite" ? faStar : faList} style={{marginRight: '12px'}} />{list === "favorite" ? "Favorite" : list}
                                        {
                                            list !== "favorite" && (
                                                <Button
                                                    variant="primary"
                                                    className={"favorite-save-btn"}
                                                    onClick={(e: any) => {
                                                        e.stopPropagation();
                                                        setSelectedDelete(list);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </Button>
                                            )
                                        }
                                    </ListGroupItem>
                                ))
                            }
                        </ListGroup>
                    )
                }
            </Modal.Body>
        </Modal>
    )
};
